import Link from "next/link";
import { ArrowUpRight } from "lucide-react";

export default function ImagePreviewLink({
  currentImageUrl,
}: {
  currentImageUrl: string;
}) {
  return (
    <Link
      href={currentImageUrl}
      target="_blank"
      aria-label="Öffne Bild in neuem Tab"
      className="hover:bg-accent absolute top-0 right-0 flex size-8 items-center justify-center rounded-md"
    >
      <ArrowUpRight className="size-5 text-gray-500" strokeWidth={1.5} />
    </Link>
  );
}
